import React, { useState, useEffect } from "react";
import { useOrderDetailsService } from "../../services/component/orderDetailsService";
import PendingTable from "../pending/table/PendingTable";
import SignedTable from "../signed/table/SignedTable";
import "./Tabs.css";

const Tabs: React.FC = () => {
  const [currentTable, setCurrentTable] = useState("pending");
  const [records, setRecords] = useState<number>(0);
  const orderDetailsService = useOrderDetailsService();

  useEffect(() => {
    const unsub = orderDetailsService.totalNumberOrders$.subscribe((numberOfOrder) => {
      if (numberOfOrder !== null && !isNaN(numberOfOrder)) {
        setRecords(numberOfOrder);
      }
    });
    return unsub;
  }, [orderDetailsService]);

  return (
    <>
      <div>
        <ul className="nav nav-tabs" role="tablist">
          <li
            role="presentation"
            className={currentTable === "pending" ? "active" : ""}
            onClick={() => setCurrentTable("pending")}
          >
            <a role="tab" className="ponter-hand">Pending ({records})</a>
          </li>
          <li
            role="presentation"
            className={currentTable === "signed" ? "active" : ""}
            onClick={() => setCurrentTable("signed")}
          >
            <a role="tab" className="ponter-hand">Signed</a>
          </li>
        </ul>
      </div>
      <div id="table-wrapper">
        {currentTable === "pending" && <PendingTable />}
        {currentTable === "signed" && <SignedTable />}
      </div>
    </>
  );
};

export default Tabs;
